<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--300" no-body>
                    <div class="px-4">
                        <div class="text-center mt-5">
                            <h3>먹물조황</h3>
                            <div class="h6 mt-4">
                                도시의 수질 향상과 환경 보호를 목표로 하며, 효율적이고 지속 가능한 상하수도 시설을 구축하고 있습니다.
                            </div>
                        </div>
                        <div class="mt-5 py-5 border-top">
                            <div class="row justify-content-center">
                                <div class="row col-lg-12" style="display: flex;">
                                    <div class="col-lg-6 card-div">
                                        <img src="img/theme/outdoor3.png" width="100%">
                                    </div>
                                    <div class="col-lg-6 card-div">
                                        <div>
                                            <p>
                                                &nbsp;&nbsp;다옴토건은 상하수도 시스템 설계 및 구축 분야에서의 전문 지식을 가지고 있습니다. 
                                                <br><br>&nbsp;&nbsp;최신 기술과 첨단 장비를 활용하여 효율적이고 지속 가능한 인프라를 구축하며, 환경 보호와 장기적 비용 절감을 목표로 하고 있습니다. 
                                                <br><br>&nbsp;&nbsp;다옴토건의 상하수도 솔루션은 공공 및 민간부문의 다양한 요구에 부응하며, 안전성과 환경적 책임을 최우선으로 삼고 있습니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="line"></div>
                            <div class="text-center mt-5">
                                <h3>대표공사실적</h3>
                            </div>
                            <div class="row card-header-bus">
                                <img src="img/theme/main10.png" style="width: 100%;">
                                <div style="background-color: #000000e3; width: 100%; padding: 30px; text-align: left;">
                                    <div class="font-20">가양대교</div>
                                    <div class="font-15">위치 : 서울시 강서구 가양동 가양대교 14</div>
                                    <div class="font-15">사업내용 : 도로증축 (L=4.62km, 교량 9개소 1,502m, 터널 1개소 389m, 출입시설 2개소)</div>
                                </div>
                            </div>
                            <div class="text-center mt-5" style="margin-bottom: 20px;">
                                <h3 style="font-weight: 300;">주요공사실적</h3>
                            </div>
                            <div style="border: 1px solid black">
                                <ul class="ul">
                                    <li>· 소미건설(주) 우수관연결공사</li>
                                    <li>· 남성사계시장 빗물받이 보수공사</li>
                                    <li>· (주)대운전력개발 관로공사</li>
                                    <li>· 광진구 하수관로 개량공사</li>
                                    <li>· 강남구 상수도 공사</li>
                                    <li>· 용산구 하수관로 정비공사</li>
                                    <li>· 이촌 가정하수관 포장·시설공사</li>
                                    <li>· 서울대학교 오수맨홀 보수공사</li>
                                    <li>· 마들공원 우수연결공사</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>
export default {};
</script>
<style>
.line {
    border-bottom: 1px solid #e9ecef;
    padding-bottom: 40px;
    margin-bottom:  40px;
}

.mid-line{
    border-bottom: 3px solid black;
    width: 40px;
    border-radius: 1em;
    margin-bottom: 30px;
}

.header-text{
    font-size: 25px;
    font-weight: 300;
    padding-bottom: 10px;
}

.card-div{
    width: 100%;
    /* height: 100%; */
    padding: 0px 30px 0px 30px;
}

.card-header-bus{
    color:#FFF; 
    font-weight: 300;
    padding: 60px 0 60px 0;
    display: flex;
    justify-content: center;
    background-color: #FFF;
}

.bg-white-gray{
    background-color: #f3f3f3;
}

.ul{
    display: block;
}
.ul > li{
    display: inline-block;
    position: relative;
    font-size: 15px;
    color: #666;
    padding-left: 10px;
    display: inline-block;
    width: 300px;
    vertical-align: top;
    margin: 10px 0;
}

.font-20{
    font-size: 20px;
}
.font-15{
    font-size: 15px;
}
</style>
